<template>
  <div class="body">
    <div class="is-pay" :class="{'is-pay-cancel':yaoinfo.orderInfo.status == 5 || yaoinfo.orderInfo.status == 6,'is-pay-done':yaoinfo.orderInfo.status != 5 && yaoinfo.orderInfo.status != 6 && yaoinfo.orderInfo.status != 1,'is-pay':yaoinfo.orderInfo.status == 1}">
      <i class="icon" :class="{'icon-cancel':yaoinfo.orderInfo.status == 5 || yaoinfo.orderInfo.status == 6,'icon-time':yaoinfo.orderInfo.status != 5 && yaoinfo.orderInfo.status != 6&& yaoinfo.orderInfo.status != 1,'icon-payfalse':yaoinfo.orderInfo.status == 1}"></i>
      <h3>{{order_status}}</h3>
      <p v-if="yaoinfo.orderInfo.status == 1">剩余{{pay_end_time_txt}}自动取消</p>
    </div>
    <div v-if="yaoinfo.orderInfo.status == 1 && shouList.length==0">
      <div class="add-add" @click="goAddress">
        <i class="icon icon-add-add"></i>
        新增收货地址
      </div>
    </div>
    <div class="shou-box" v-if="shouList.length!=0 && yaoinfo.orderInfo.status == 1" @click="goAddList">
      <h3>
        <span>收货人：{{cdefault.zname}}</span>
        <span>{{cdefault.mobile?cdefault.mobile.slice(0,3)+'****'+cdefault.mobile.slice(-4):''}}</span>
      </h3>
      <p>收货地址：{{cdefault.province}} {{cdefault.city}} {{cdefault.area}} {{cdefault.address}}</p>
      <i class="icon icon-enter"></i>
    </div>
    <div class="order-2-box" v-if="yaoinfo.orderInfo.status != 1">
      <div class="order-2-title">
        <div class="order-2-t-left font-85">{{yf_type_name}}</div>
        <div class="order-2-t-right" v-if="yaoinfo.orderInfo.status != 5 && yaoinfo.orderInfo.status != 6">医师：{{yaoinfo?yaoinfo.orderInfo.docname:''}}</div>
      </div>
      <div
        class="order-2-content font-65"
      >收货人：{{yaoinfo?yaoinfo.orderInfo.consignee:''}} {{phonecode(yaoinfo?yaoinfo.orderInfo.con_mobile:'')}}</div>
      <div class="order-2-content1 font-65">收货地址：{{yaoinfo?yaoinfo.orderInfo.address:''}}</div>
      <div
        class="order-2-content1 font-65"
        style="margin-top:1rem;"
        v-if="yaoinfo.orderInfo.status == 4"
      >配送方式：{{yaoinfo && yaoinfo.orderInfo.address_type == 2?'自取':yaoinfo && yaoinfo.orderInfo.express_id?yaoinfo.orderInfo.express_name:'快递'}}</div>
      <div
        class="order-2-content1 font-65 dis_f_s"
        v-if="yaoinfo.orderInfo.status == 4"
      >
        快递单号：{{yaoinfo && yaoinfo.orderInfo.express_sn?yaoinfo.orderInfo.express_sn:''}}
        <div class="copy-box" v-if="yaoinfo && yaoinfo.orderInfo.express_sn" v-clipboard:copy="yaoinfo && yaoinfo.orderInfo.express_sn?yaoinfo.orderInfo.express_sn:''" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</div>
      </div>
    </div>
    <div class="pres" :class="{'active':is_toggle}">
      <div class="pres-head">处方</div>
      <div class="pat-cont font-85">
        <div class="pat-item">
          <p>姓名</p>
          <div class="pat-item-detail">{{yaoinfo.orderInfo.patient_name}}</div>
        </div>
        <div class="pat-item">
          <p>性别</p>
          <div class="pat-item-detail">{{yaoinfo.orderInfo.patient_sex == 1?'男':'女'}}</div>
        </div>
        <div class="pat-item">
          <p>年龄</p>
          <div class="pat-item-detail">{{yaoinfo.orderInfo.patient_age}}岁</div>
        </div>
        <div class="pat-item">
          <p>科别</p>
          <div class="pat-item-detail">{{yaoinfo.yaoInfo.department}}</div>
        </div>
      </div>
      <div class="zhenduan" :class="{'no-show':yaoinfo.yaoInfo.is_show == 2}">
        <p>诊断：{{yaoinfo.yaoInfo.sike}}</p>
        <!--<p style="position:relative;" v-if="yaoinfo.yaoInfo.is_show == 2">
          支付后即可查看处方
          <span class="yao-num" v-if="yaoinfo.yaoInfo.typeid !=3 && yaoinfo.yaoInfo.typeid !=4">共{{yaoinfo.yaoInfo.content.length}}味</span>
          <span class="yao-num" v-else>共{{yaoinfo.yaoInfo.content.length}}种</span>
        </p>-->
      </div>

      <div class="yf-box"><!--v-if="yaoinfo.yaoInfo.is_show == 1"-->
        <div class="yf-title">
          <div class="yf-title-left font-85">R:</div>
          <div
            class="yf-title-right font-65"
          >{{yt_type_name}}</div>
        </div>
        <!-- 饮片颗粒等中药 -->
        <div class="yf-content" v-if="yaoinfo.yaoInfo.typeid !=3 && yaoinfo.yaoInfo.typeid !=4">
          <div
            class="yf-content-box font-65"
            v-for="(item,index) in yaoinfo.yaoInfo.content"
            :key="index"
          >{{item.nikename}} <span v-if="yaoinfo.orderInfo.status == 2||yaoinfo.orderInfo.status == 3||yaoinfo.orderInfo.status == 4">{{item.num}}{{item.company}}</span></div>
        </div>
        <div
          class="yf-use-limit font-65"
          v-if="yaoinfo.yaoInfo.typeid == 1 || yaoinfo.yaoInfo.typeid == 2 "
        >
          <span class="font-85" style="margin-right:0.5rem;">用法用量</span>
          {{yaoinfo.yaoInfo.usage == 1?'内服；':yaoinfo.yaoInfo.usage == 2?'外服；':''}}
          <span
            v-if="use_limit.length"
          >共{{use_limit[0]}}剂，每日{{use_limit[1]}}剂，1剂分{{use_limit[2]}}次服用</span>
        </div>
        <div
          class="yf-use-limit font-65"
          v-if="yaoinfo.yaoInfo.typeid == 5 || yaoinfo.yaoInfo.typeid == 6 ||yaoinfo.yaoInfo.typeid==7"
        >
          <span class="font-85" style="margin-right:0.5rem;">用法用量</span>
          {{yaoinfo.yaoInfo.usage == 1?'内服；':yaoinfo.yaoInfo.usage == 2?'外服；':''}}
          <span
            v-if="use_limit.length"
          >每日{{use_limit[0]}}次，每次{{use_limit[1]}}克，约服{{use_limit[2]}}-{{use_limit[3]}}天</span>
        </div>
        <div class="yf-use-limit font-65" v-if="yaoinfo.yaoInfo.typeid == 8">
          <span class="font-85" style="margin-right:0.5rem;">用法用量</span>
          {{yaoinfo.yaoInfo.usage == 1?'内服；':yaoinfo.yaoInfo.usage == 2?'外服；':''}}
          <span
            v-if="use_limit.length"
          >每日{{use_limit[0]}}丸，每丸{{use_limit[1]}}克，分{{use_limit[2]}}次服用，约服{{use_limit[3]}}-{{use_limit[4]}}天</span>
        </div>
        <!-- 中成药西药 -->
        <div class="yf-xy-box" v-if="yaoinfo.yaoInfo.typeid ==3 || yaoinfo.yaoInfo.typeid ==4">
          <div class="yf-xy-list" v-for="(item,index) in yaoinfo.yaoInfo.content" :key="index">
            <div class="yf-xy-title">
              <div class="yf-xy-t-left font-65">{{item.nikename}}</div>
              <div class="yf-xy-t-right font-65">{{item.num}}{{item.company}}</div>
            </div>
            <div class="yf-xy-content">
              <div class="yf-xy-c-left">{{item.stand}}</div>
              <div class="yf-xy-c-right">{{item.sale_price}}元</div>
            </div>
            <div class="yf-xy-factory">{{item.factory}}</div>
            <div class="yf-xy-use-limit font-65">
              <span class="font-85" style="margin-right:0.4rem;">用法用量</span>
              {{item.use_limit}}
            </div>
          </div>
        </div>
        <div class="yz font-85">医嘱提醒</div>
        <div class="yz-box">
          <div class="yy-jj font-65">
            <span class="font-85" style="margin-right:0.5rem;">用药禁忌</span>
            {{yaoinfo.yaoInfo.remind}}
          </div>
          <div class="yy-sj font-65">
            <span class="font-85" style="margin-right:0.5rem;">服药时间</span>
            {{yaoinfo.yaoInfo.med_time}}
          </div>
          <div class="yy-bc font-65">
            <span class="font-85" style="margin-right:0.5rem;">补充说明</span>
            {{yaoinfo.yaoInfo.ext_explain}}
          </div>
        </div>
      </div>
      <div class="docname font-85" :class="{'no-active':yaoinfo.yaoInfo.is_show == 2}">医师：{{yaoinfo.orderInfo.docname}}</div>
    </div>
    <div class="prices server-box" v-if="yaoinfo.yaoInfo.typeid==1 && yaoinfo.orderInfo.status == 1">
        <div class="price-item">
          <span>是否代煎</span>
          <span>
            <label>
              <input name="servers" type="radio" :checked="cook==1" @change="getyaoinfo(1)">代煎
            </label>
            <label>
              <input name="servers" type="radio" :checked="cook==2" @change="getyaoinfo(2)">自煎
            </label>
          </span>
        </div>
      </div>
    <div class="toggle-box font-85" v-if="yaoinfo.yaoInfo.is_show == 1" @click="handleToggle">
      {{toggle_txt}}
      <img :src="toggle_img" alt />
    </div>
    <div class="prices">
      <div class="price-item">
        <span>药方总价</span>
        <span>￥{{(yaoinfo.yaoInfo.yao_money/100).toFixed(2)}}</span>
      </div>
      <div class="price-item" v-if="cook == 1">
        <span>加工费</span>
        <span>￥{{(yaoinfo.yaoInfo.servier_money/100).toFixed(2)}}</span>
      </div>
      <!--<div class="price-item">
        <span>运费</span>
        <span>￥{{(yaoinfo.orderInfo.yun_money/100).toFixed(2)}}</span>
      </div>-->
      <div class="price">
        <span>合计：</span>
        <span class="font-red">￥{{(yaoinfo.orderInfo.charge_amount/100).toFixed(2)}}</span>
      </div>
      <span class="peisong">配送方式：快递{{yaoinfo.yaoInfo.is_free == 1?'（货到付款）':'（包邮）'}}</span>
    </div>
    <div class="order-detail-box" v-if="yaoinfo.orderInfo.status != 1">
      <div class="order-detail-1 font-65">订单编号：{{yaoinfo.orderInfo.order_sn}}</div>
      <div class="order-detail-1 font-65">
        联系客服：
        <a :href="'tel:'+customer_phone">{{customer_phone}}</a>
      </div>
      <div class="order-detail-1 font-65">
        物流及药品质量投诉电话：
        <a :href="'tel:'+customer_phone">{{customer_phone}}</a>
      </div>
    </div>
    <div class="mask" v-if="paying"></div>
    <div class="pay-bottom" v-if="yaoinfo.orderInfo.status == 1 && pay_end_time_txt.indexOf('0时0分')==-1">
      <div class="kefu" @click="handleCall">
        <i class="icon icon-kefu"></i>
        <div class="kefu-txt">客服</div>
      </div>
      <div class="pay-price">实付：{{(yaoinfo.orderInfo.charge_amount/100).toFixed(2)}}元</div>
      <div class="pay-btn" @click="gopay">去支付</div>
    </div>
  </div>
</template>

<script>
import http from "../../request/http";
import { getCustomerPhone } from "../../utils/index";
export default {
  name: "order_pay",
  data() {
    return {
      yaoinfo: {
        orderInfo: {
          patient_name: "",
        },
        yaoInfo: {
          department: "",
          content: [],
        },
      },
      orderid: "",
      cid: "",
      shouList: [],
      cdefault: {},
      order_status: "",
      yf_type_name: "", //药方
      yt_type_name: "", //药态
      use_limit: [],
      toggle_txt: "收起",
      toggle_img: "../../../static/icons/pack up@3x.png", //develop@3x.png
      is_toggle: true,
      customer_phone:'',
      pay_end_time:0,
      pay_end_time_txt: '0时0分',
      timerOut:null,
      paying:false,
      cook:1
    };
  },
  created() {
    this.orderid = this.$route.query.orderid;
    this.cid = this.$route.query.cid;
    this.getclist();
    if (this.orderid) {
      this.getyaoinfo('');
    }
  },
  mounted() {
    this.customer_phone = this.$cookies.get("customer_phone")
    let appbox = document.getElementById("app");
        appbox.scrollTop = 0;

  },
  methods: {
    handleCall() {
      if (this.$cookies.get("customer_phone")) {
        window.location.href = `tel:${this.$cookies.get("customer_phone")}`;
      } else {
        getCustomerPhone(this, (phone) => {
          window.location.href = `tel:${phone}`;
        });
      }
    },
    onCopy(e){
      this.$toast.center('复制成功')
    },
    onError(e){
      console.log(e,"失败");
    },
    phonecode(tel){
      var reg = /^(\d{3})\d{4}(\d{4})$/;
      if(tel){
        return tel.replace(reg, "$1****$2");
      }else{
        return '';
      }
    },
    handleToggle() {
      this.is_toggle = !this.is_toggle;
      if (this.is_toggle) {
        this.toggle_txt = "收起";
        this.toggle_img = "../../../static/icons/pack up@3x.png";
      } else {
        this.toggle_txt = "点此查看处方";
        this.toggle_img = "../../../static/icons/develop@3x.png";
      }
    },
    yf_type(val) {
      let txt = "";
      switch (val) {
        case "1":
          txt = "饮片";
          break;
        case "2":
          txt = "颗粒";
          break;
        case "4":
          txt = "中成药";
          break;
        case "8":
          txt = "西药";
          break;
        default:
          txt = "";
      }
      return txt;
    },
    yt_type(val) {
      let txt = "";
      switch (val) {
        case "1":
          txt = "饮片";
          break;
        case "2":
          txt = "颗粒";
          break;
        case "3":
          txt = "中成药";
          break;
        case "4":
          txt = "西药";
          break;
        case "5":
          txt = "水丸";
          break;
        case "6":
          txt = "膏方";
          break;
        case "7":
          txt = "粉剂";
          break;
        case "8":
          txt = "蜜丸";
          break;
        default:
          txt = "";
      }
      return txt;
    },
    charge_status(val) {
      let txt = "";
      switch (val) {
        case "1":
          txt = "待支付";
          break;
        case "2":
          txt = "待审方";
          break;
        case "3":
          txt = "待发药";
          break;
        case "4":
          txt = "已发药";
          break;
        case "5":
          txt = "订单已作废";
          break;
        case "6":
          txt = "订单已超时";
          break;
        default:
          txt = "";
      }
      return txt;
    },
    addZero(i) {
      return i < 10 ? "0" + i : i + "";
    },
    count_down() {
      let nowtime = new Date().getTime();
      let endtime = this.pay_end_time;
      let lefttime = parseInt((endtime - nowtime) / 1000);
      if (lefttime <= 0) {
        if (this.timerOut) {
          clearTimeout(this.timerOut);
          this.timerOut = null;
        }
        return;
      }
      let h = parseInt(lefttime / (60 * 60));
      let m = parseInt((lefttime / 60) % 60);
      h = this.addZero(h);
      m = this.addZero(m);
      this.pay_end_time_txt = `${h}时${m}分`;
      this.timerOut = setTimeout(this.count_down, 1000);
    },
    getyaoinfo(cook) {
      http
        .post("/api/wap/order/yaoinfo", {
          order_id: this.orderid,
          cook:cook
        })
        .then((res) => {
          this.yf_type_name = this.yf_type(res.data.yaoInfo.yaofang_type);
          this.yt_type_name = this.yt_type(res.data.yaoInfo.typeid);
          this.order_status = this.charge_status(res.data.orderInfo.status);
          this.use_limit = res.data.yaoInfo.use_limit
            ? res.data.yaoInfo.use_limit.split("_")
            : [];
          this.pay_end_time = res.data.orderInfo.ctime * 1000 + 1000 * 60 * 60 * 24 * 3;
          this.count_down();
          this.yaoinfo = res.data;
          this.cook = res.data.yaoInfo.cook;
        });
    },
    goAddress() {
      this.$router.push({
        name: "address_edit",
        query: {
          from: "order_pay_detail",
          orderid: this.orderid,
        },
      });
    },
    goAddList() {
      this.$router.push({
        name: "address_list",
        query: {
          from: "order_pay_detail",
          orderid: this.orderid,
          cid: this.cid,
        },
      });
    },
    getclist() {
      http.post("/api/wap/user/consigneelist").then((res) => {
        this.shouList = res.data;
        if(res.data.length != 0){
          res.data.forEach((e) => {
            if (this.$route.query.cid){
              if(this.$route.query.cid == e.id) {
                this.cdefault = e;
                this.cid = e.id;
              }
            } else{
              if (e.default == 1){
                this.cdefault = e;
                this.cid = e.id;
              }else{
                this.cdefault = this.shouList[0];
                this.cid = this.shouList[0].id;
              }
            }
          });
        }
      });
    },
    gopay(){
      if(this.cid == ''||this.cid == null){
        this.$toast.center('请选择收货人')
      }else{
        this.paying = true;
        http.post("/api/wap/order/yaopay", {
            order_id: this.orderid,
            cid: this.cid,
            currency: "cny",
            channel: "wx_pub",
          }).then((res) => {
            if (res.errno == 0) {
              let pingpp = require("pingpp-js");
              pingpp.createPayment(res.data, (result, err) => {
                if (result == "success") {
                  // 只有微信公众账号 (wx_pub)、微信小程序 (wx_lite)、QQ 公众号 (qpay_pub)、支付宝口碑 (alipay_qr)
                  // 支付成功的结果会在这里返回，其他的支付结果都会跳转到 extra 中对应的 URL。
                  this.paying = false;
                  this.$toast.center("支付成功");
                  this.$router.push("/my_shop_car");
                } else if (result == "fail") {
                  // data 不正确或者微信公众账号/微信小程序/QQ 公众号/支付宝口碑支付失败时会在此处返回
                  this.$toast.center("支付异常，请重试");
                  this.paying = false;
                } else if (result == "cancel") {
                  // 微信公众账号、微信小程序、QQ 公众号、支付宝口碑支付取消支付
                  console.log("wx_pub cancel");
                  this.$toast.center("取消支付");
                  this.paying = false;
                }
              });
            }else{
              this.$toast.center(res.errmsg);
              this.paying = false;
            }
          }).catch(err => {
            console.log(err)
            this.paying = false;
          })
      }
    },
  },
  destroyed(){
    if (this.timerOut) {
      clearTimeout(this.timerOut);
      this.timerOut = null;
    }
  }
};
</script>

<style scoped>
.body {
  padding-top: 0;
}
.is-pay.is-pay-done{
  background: url('../../../static/icons/wdbj_bg@3x.png') no-repeat;
  background-size: 100% 100%;
}
.is-pay.is-pay-cancel{
  background: url('../../../static/icons/wdbj_bg_gray@3x.png') no-repeat;
  background-size: 100% 100%;
}
.icon-time,.icon-cancel,.icon-payfalse {
  content: url("../../../static/icons/car@3x.png");
  width: 1rem;
  height: 1rem;
  margin-right: 0.6rem;
}
.icon-cancel{
  content: url("../../../static/icons/close_s@3x.png");
}
.icon-payfalse{
  content: url("../../../static/icons/To_be_paid@3x.png");
}
.is-pay {
  background: url("../../../static/icons/wdbj_bg_red@3x.png") no-repeat;
  padding: 0 1rem;
  justify-content: flex-start;
  align-items: center;
}
.is-pay h3 {
  font-size: 1rem;
  font-weight: 400;
}
.is-pay p {
  font-size: 0.6rem;
  margin-left: 0.6rem;
  line-height: 1.2rem;
}
.add-add {
  border-bottom: 0.05rem solid #f5f5f5;
  margin: 0;
}
.exps {
  width: 100%;
  height: 2.7rem;
  background: #fff;
  padding: 0 1rem;
  line-height: 2.7rem;
  font-size: 0.7rem;
  color: rgba(0, 0, 0, 0.65);
}
.pres {
  width: 100%;
  height: 0;
  overflow: hidden;
  background: #feffe6;
  transition: all 0.5s linear;
}
.active {
  height: auto;
}
.pres-head {
  width: 100%;
  height: 2.8rem;
  text-align: center;
  font-size: 1rem;
  padding-top: 1rem;
  border-bottom: 0.05rem solid #f5f5f5;
  font-weight: 700;
}
.pat-cont {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 1rem;
  margin-bottom: 2rem;
}
.pat-item {
  text-align: center;
  font-size: 16px;
}
.pat-item p {
  font-size: 0.6rem;
  color: rgba(0, 0, 0, 0.45);
  margin-bottom: 0.4rem;
}
.zhenduan {
  padding: 0 1rem;
  margin-bottom: 2rem;
}
.zhenduan p {
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.65);
  line-height: 1.2rem;
}
.zhenduan p + p{
  margin-top: 0.4rem;
}
.docname {
  line-height: 1.2rem;
  font-size: 0.8rem;
  text-align: right;
  padding: 0 1rem;
  width: 100%;
  margin-top: 1rem;
}
.prices {
  padding: 1rem;
  background: #fff;
}
.price-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.65);
  height: 1.2rem;
}
.price-item + .price-item{
  margin-top: 0.4rem;
}
.price {
  display: flex;
  justify-content: space-between;
  padding-top: 1rem;
  height: 2.5rem;
  font-size: 0.8rem;
  border-top: 0.05rem solid #f5f5f5;
  margin-top: 1rem;
}
.icon-enter {
  content: url("../../../static/icons/enter@3x.png");
  width: 0.6rem;
  height: 1rem;
  position: absolute;
  top: 50%;
  right: 1rem;
  margin-top: -0.25rem;
}
.order-2-box {
  width: 100vw;
  height: auto;
  padding: 1rem;
  box-sizing: border-box;
}
.order-2-title {
  width: 100%;
  height: 1.3rem;
  margin-bottom: 1rem;
}
.order-2-t-left,
.order-2-t-right {
  width: 50%;
  height: 1.3rem;
  line-height: 1.3rem;
  font-size: 0.9rem;
  font-weight: bold;
  float: left;
}
.order-2-t-right {
  font-weight: normal;
  text-align: right;
  font-size: 0.7rem;
}
.order-2-content {
  width: 100%;
  height: 1.1rem;
  line-height: 1.1rem;
  font-size: 0.7rem;
}
.order-2-content1 {
  min-height: 1.1rem;
  line-height: 1.1rem;
  font-size: 0.7rem;
  margin-top: 0.4rem;
  width: 100%;
}
.yf-box {
  width: 100%;
  padding: 0 1rem;
  box-sizing: border-box;
}
.yf-title {
  width: 100%;
  height: 1.4rem;
  margin-bottom: 0.5rem;
}
.yf-title-left {
  width: 2rem;
  height: 1.4rem;
  line-height: 1.4rem;
  float: left;
  font-size: 1rem;
  font-weight: bold;
}
.yf-title-right {
  width: calc(100% - 2rem);
  padding-left: 1rem;
  box-sizing: border-box;
  float: left;
  height: 1.4rem;
  line-height: 1.4rem;
  font-size: 0.8rem;
  text-align: right;
}
.yf-content {
  width: 100%;
  padding: 1rem 0 0;
  box-sizing: border-box;
  border-top: 0.05rem dashed rgba(0, 0, 0, 0.09);
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: center;
  flex-wrap: wrap;
  margin-bottom: 0.2rem;
}
.yf-content-box {
  width: auto;
  height: 1.2rem;
  line-height: 1.2rem;
  font-size: 0.8rem;
  margin: 0 1.6rem 0.8rem 0;
}
.yf-use-limit,
.yf-dj,
.yy-jj,
.yy-sj,
.yy-bc {
  width: 100%;
  line-height: 1.2rem;
  font-size: 0.8rem;
  margin-bottom: 1rem;
}
.yf-dj {
  margin-bottom: 2rem;
}
.yz {
  width: 100%;
  height: 1.3rem;
  line-height: 1.3rem;
  font-size: 0.9rem;
  font-weight: bold;
  margin-bottom: 0.4rem;
}
.yz-box {
  padding: 1rem 0 0;
  box-sizing: border-box;
  border-top: 0.05rem dashed rgba(0, 0, 0, 0.09);
}
.toggle-box {
  width: 100%;
  height: 3.1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.7rem;
  background: #feffe6;
}
.toggle-box img {
  width: 0.7rem;
  height: 0.7rem;
  vertical-align: middle;
  margin-left: 0.4rem;
}
.order-detail-box {
  width: 100%;
  padding: 1rem;
  box-sizing: border-box;
  background: #fff;
  margin-top: 0.4rem;
}
.order-detail-1 {
  width: 100%;
  height: 1.2rem;
  line-height: 1.2rem;
  font-size: 0.8rem;
}
.order-detail-1 + .order-detail-1 {
  margin-top: 0.4rem;
}
.order-detail-1 a {
  color: #1890ff;
}
.yf-xy-box {
  width: 100%;
  padding: 1.5rem 0 0;
  box-sizing: border-box;
  border-top: 0.05rem dashed rgba(0, 0, 0, 0.09);
}
.yf-xy-list {
  width: 100%;
}
.yf-xy-list + .yf-xy-list {
  margin-top: 1.5rem;
}
.yf-xy-list:last-child {
  margin-bottom: 2rem;
}
.yf-xy-title {
  width: 100%;
  height: 1.2rem;
  margin-bottom: 0.2rem;
}
.yf-xy-t-left,
.yf-xy-t-right,
.yf-xy-c-left,
.yf-xy-c-right {
  width: 60%;
  float: left;
  height: 1.2rem;
  line-height: 1.2rem;
  font-size: 0.8rem;
}
.yf-xy-t-right,
.yf-xy-c-right {
  width: 40%;
  text-align: right;
}
.yf-xy-content {
  width: 100%;
  height: 1rem;
}
.yf-xy-c-left,
.yf-xy-c-right,
.yf-xy-factory {
  height: 1rem;
  line-height: 1rem;
  font-size: 0.6rem;
  color: rgba(0, 0, 0, 0.25);
}
.yf-xy-use-limit {
  width: 100%;
  height: 1.2rem;
  line-height: 1.2rem;
  font-size: 0.8rem;
  margin-top: 0.8rem;
}
.copy-box {
  color: rgba(24, 144, 255, 1);
  margin-left: 0.6rem;
}
.dis_f_s {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.no-show{
  margin-bottom: 1rem;
}
.yao-num{
  position: absolute;
  top:0;
  right: 0;
}
.no-active{
  padding:1rem;
  border-top: 0.05rem solid rgba(245, 245, 245, 1);
}
.pat-item-detail{
  height: 1.2rem;
  line-height: 1.2rem;
  font-size: 0.8rem;
}
.shou-box {
  background: #fff;
  padding: 1rem;
  padding-right: 2.3rem;
  position: relative;
}
.shou-box h3 {
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.4rem;
}
.shou-box p {
  line-height: 1.1rem;
  font-size: 0.7rem;
  color: rgba(0, 0, 0, 0.65);
}
.pay-bottom{
  display: block;
  padding:0.4rem 1rem;
}
.pay-bottom .pay-price {
  width: calc(100% - 7.75rem);
  text-align: left;
  float: left;
  height: 2rem;
  line-height: 2rem;
}
.kefu{
  width: auto;
  float: left;
  padding-top: 0.1rem;
}
.pay-btn{
  width: auto;
  float: left;
  padding:0 1.6rem;
}
.kefu-txt{
  width: 100%;
  height: 1rem;
  line-height: 1rem;
  font-size: 0.6rem;
  margin-top: 0.1rem;
}
.server-box{
  margin: 0.5rem 0;
  height: 2.8rem;
}
.server-box input{
  margin-right: 0.4rem;
}
.server-box label:first-child{
  margin-right: 1.5rem;
}
  .peisong{
    font-size: 0.7rem;
    color: #ed943e;
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/order_pay_detail.vue